module.exports = __webpack_public_path__ + "img/groovepay_banner.498c0338.png";